<h1 mat-dialog-title>Dodaj opis</h1>
<div mat-dialog-content>
	<div class="mb-3">
		<ng-select
			id="location"
			name="location"
			class="custom-ng-select"
			[(ngModel)]="data.header"
			placeholder="(wybierz)"
			required
		>
			<ng-option *ngFor="let item of data.descriptionheaders" [value]="item.id"> {{ item.name }}</ng-option>
		</ng-select>
	</div>

	<h6>Opis<small class="ms-2 text-danger">* wymagane</small></h6>
	<div class="form-floating mb-3">
		<ckeditor
			id="description"
			name="description"
			[(ngModel)]="data.description"
			[editor]="editor"
			[config]="editorConfig"
		></ckeditor>
	</div>
</div>
<div class="float-end" mat-dialog-actions>
	<button color="primary" class="me-2" mat-raised-button [mat-dialog-close]="data">Zapisz</button>
	<button color="warn" mat-raised-button (click)="onCloseClick()">Zamknij</button>
</div>
